<template>
  <div class="data_tabs">
    <a-tabs type="card" style="background: #ffffff">
      <a-tab-pane key="1" tab="基本信息">
        <asset-detail ref="assetDetail" :model="model"></asset-detail>
      </a-tab-pane>
      <a-tab-pane key="2" tab="关联设备">
        <accessory-management ref="accessoryManagement"></accessory-management>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import AssetDetail from './assetDetail.vue'
import AssetFlow from './assetFlow.vue'
import AssetWorth from './assetWorth.vue'
import AssociateDevice from './associateDevice.vue'
import AssetEngineeringDetail from './assetEngineeringDetail.vue'
import AccessoryManagement from './accessoryManagement.vue'
export default {
  props: {
    model: Object,
  },
  components: {
    AssetDetail,
    AssetWorth,
    AssociateDevice,
    AssetFlow,
    AssetEngineeringDetail,
    AccessoryManagement
  },
  data  () {
    return {}
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.data_tabs {
  /deep/.ant-tabs-bar {
    border: 0;
    margin-bottom: 0;
    .ant-tabs-nav-container {
      padding-left: 8px;
      border-bottom: 1px solid #DDDDDD;
      // border: 0;

      .ant-tabs-tab {
        border: 0;
        height: 26px;
        line-height: 26px;
        padding: 0 10px;
        margin: 7px 0;
        margin-right: 16px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
      }
      .ant-tabs-tab-active {
        color: #1791FF;
        background: rgba(23, 145, 255, 0.1);
      }
    }
  }

  // /deep/.ant-tabs-tab{
  //   border: 0 !important;
  //   height: 26px !important;
  //   line-height: 26px !important;
  //   padding: 0 10px !important;
  //   margin: 7px 0 !important;
  //   margin-right: 16px !important;
  // }
  // /deep/.ant-tabs-tab-active{
  //   background: rgba(23, 145, 255, 0.1) !important;
  // }
}
</style>